// @ts-ignore
import { convertFrequency } from 'hertzbel';

import {
  freqSplit,
  getCenterWithLo,
  getCenterWithoutLo,
} from '../../../utils/FreqUtils';
import { SnapshotTraceHistoryCombination } from '../types';

export interface SettingsAction {
  type:
    | 'port-changed'
    | 'center-value-changed'
    | 'center-unit-changed'
    | 'lo-mode-changed'
    | 'lo-value-changed'
    | 'lo-unit-changed'
    | 'span-value-changed'
    | 'span-unit-changed'
    | 'scale-changed'
    | 'property-changed'
    | 'inverted-changed'
    | 'sweep-mode-changed'
    | 'snapshot-changed';
  value?: any;
  name?: any;
  snapshot?: SnapshotTraceHistoryCombination;
}

const snapshotSettingsReducer = (
  snapshot: SnapshotTraceHistoryCombination,
  action: SettingsAction
): SnapshotTraceHistoryCombination => {
  switch (action.type) {
    case 'port-changed': {
      let port = action.value <= 0 ? 1 : action.value;
      if (action.value === '') port = '';

      return {
        ...snapshot,
        port: port,
      };
    }
    case 'center-value-changed': {
      if (action.value === '')
        return {
          ...snapshot,
          center: ' ' + freqSplit(snapshot.center)[1],
        };
      return {
        ...snapshot,
        center: Math.abs(action.value) + ' ' + freqSplit(snapshot.center)[1],
      };
    }
    case 'center-unit-changed': {
      return {
        ...snapshot,
        center: convertFrequency(snapshot.center, action.value),
      };
    }
    case 'lo-value-changed': {
      const loValue = Math.abs(action.value) + ' ' + freqSplit(snapshot.lo)[1];
      const { center, lo, lo_mode } = snapshot;
      const centerWithoutLo = getCenterWithoutLo(center, lo);
      const centerWithLo = getCenterWithLo(centerWithoutLo, loValue, lo_mode);

      return {
        ...snapshot,
        center: centerWithLo,
        lo: loValue,
      };
    }
    case 'lo-unit-changed': {
      const loValue = convertFrequency(snapshot.lo, action.value);
      const { center, lo, lo_mode } = snapshot;
      const centerWithoutLo = getCenterWithoutLo(center, lo);
      const centerWithLo = getCenterWithLo(centerWithoutLo, loValue, lo_mode);

      return {
        ...snapshot,
        center: centerWithLo,
        lo: loValue,
      };
    }
    case 'lo-mode-changed': {
      const centerWithoutLo = getCenterWithoutLo(snapshot.center, snapshot.lo);

      return {
        ...snapshot,
        center: centerWithoutLo,
        lo: '0 MHz',
        lo_mode: action.value,
      };
    }
    case 'span-value-changed': {
      if (action.value === '')
        return { ...snapshot, span: ' ' + freqSplit(snapshot.span)[1] };
      return {
        ...snapshot,
        span: Math.abs(action.value) + ' ' + freqSplit(snapshot.span)[1],
      };
    }
    case 'span-unit-changed': {
      return {
        ...snapshot,
        span: convertFrequency(snapshot.span, action.value),
      };
    }
    case 'scale-changed': {
      let scale = action.value <= 0 ? '' : action.value;

      if (action.value === '') scale = '';
      return {
        ...snapshot,
        scale: scale,
      };
    }
    case 'inverted-changed': {
      return { ...snapshot, inverted: action.value };
    }
    case 'sweep-mode-changed': {
      return {
        ...snapshot,
        sweep_time_mode: action.value,
        manual_sweep_time: snapshot.manual_sweep_time
          ? snapshot.manual_sweep_time
          : '1000',
      };
    }
    case 'property-changed': {
      return {
        ...snapshot,
        [action.name]: action.value,
      };
    }
    case 'snapshot-changed': {
      if (!action.snapshot) return snapshot;
      return {
        ...action.snapshot,
        center: getCenterWithLo(
          action.snapshot.center,
          action.snapshot.lo,
          action.snapshot.lo_mode
        ),
      };
    }
    default: {
      throw Error('Unknown Action: ' + action.type);
    }
  }
};

export default snapshotSettingsReducer;
